import { BaseViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { action, observable, runInAction } from 'mobx';
import { ModalParams } from 'core/models';
import { FacilityOrderTemplateService, FacilityOrderService, FacilityInventoryCalculationService, FacilityInventoryCalculationItemService, FacilityOrderStatusService, InventoryCalculationCutbackService } from "application/facility-order/services";
import { FacilityInventoryCountHeaderService, FacilityInventoryCountDetailService } from "application/facility-inventory/services";
import { FacilityService } from 'application/facility/services';
import { ProductService } from 'application/product/services';
import { ScheduleService } from 'application/schedule/services';
import { LookupService } from "common/services";
import _ from 'lodash';
import { uuid } from "core/utils";

import { InventoryRequestService } from '../../inventory-request/services';

@applicationContext
class NikoFacilityOrderNewFlowInventoryPreviewViewStore extends BaseViewStore {
    @observable accessor facilityOrder;
    @observable accessor refreshKey = uuid();
    @observable accessor facilityInventoryCountHeader;
    @observable accessor facilityInventoryCountDetails;
    @observable accessor facilityInventoryCalculation;
    @observable accessor facilityInventoryCalculationItemsGroup;
    @observable accessor isOpenInventoryCount = true;
    @observable accessor isOpenInventoryCalculation = false;
    @observable accessor isLoading = false;
    @observable accessor isUpdateInventoryCountLoading = false;
    @observable accessor isStatusBarVisible = true;
    @observable accessor disabled = false;
    @observable accessor disabledSendOrder = false;
    @observable accessor disabledItems = [];
    @observable accessor isEdit = false;
    @observable accessor isDone = false;
    @observable accessor disabledCount = false;
    @observable accessor rebuildTooltip = false;

    @observable accessor isApprovalRequired = false;
    @observable accessor isInventoryFollowupEmail = false;
    @observable accessor isInventoryNotReceivedEmail = false;
    @observable accessor isOngoingMissingInventoryEmail = false;
    @observable accessor hideInventoryEmailButton = false;
    @observable accessor isProcessing = false;
    constructor(rootStore) {
        super(rootStore);

        this.id = rootStore.routerStore.routerState.params.id;
        this.isAdmin = this.rootStore.userStore.user.roles.includes("Administrators");

        this.facilityOrderService = new FacilityOrderService(rootStore.application.baasic.apiClient);
        this.facilityInventoryCountHeaderService = new FacilityInventoryCountHeaderService(rootStore.application.baasic.apiClient);
        this.facilityInventoryCountDetailService = new FacilityInventoryCountDetailService(rootStore.application.baasic.apiClient);
        this.productService = new ProductService(rootStore.application.baasic.apiClient);
        this.facilityInventoryCalculationService = new FacilityInventoryCalculationService(rootStore.application.baasic.apiClient);
        this.facilityInventoryCalculationItemService = new FacilityInventoryCalculationItemService(rootStore.application.baasic.apiClient);
        this.lookupService = new LookupService(rootStore.application.baasic.apiClient);
        this.facilityOrderStatusService = new FacilityOrderStatusService(rootStore.application.baasic.apiClient);
        this.inventoryCalculationCutbackService = new InventoryCalculationCutbackService(rootStore.application.baasic.apiClient);
        this.facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        this.scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);
        this.inventoryRequestService = new InventoryRequestService(rootStore.application.baasic.apiClient);

        this.nikoFacilityOrderNewFlowInventoryCountEditModal = new ModalParams({ onClose: () => this.getInventoryCount() });
        this.nikoFacilityOrderNewFlowInventoryCalculationVerificationModal = new ModalParams({ onClose: () => { } });
        this.nikoFacilityOrderNewFlowInventoryCalculationCutbackEditModal = new ModalParams({ onClose: () => this.getInventoryCalculation(), onCutbackItemUpdate: this.onCutbackItemUpdate });
        this.nikoFacilityOrderNewFlowInventoryCalculationProcessModal = new ModalParams({ onClose: () => { } });
        this.nikoFacilityOrderNewFlowMissingInventoryCountConfirmModal = new ModalParams({ onClose: () => { } });
        this.nikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal = new ModalParams({ onClose: () => { } });
        this.nikoFacilityOrderNewFlowExtraSuppliesAddModal = new ModalParams({ onClose: () => { } });

        this.extraSuppliesApprovalRequiredModal = new ModalParams({ onClose: null });
        this.extraSuppliesApprovalRequiredModal.onCancel = () => { this.extraSuppliesApprovalRequiredModal.close() };
        this.extraSuppliesApprovalRequiredModal.noLabel = 'MODAL.CANCEL_LABEL';
        this.extraSuppliesApprovalRequiredModal.swapButtons = true;

        this.statusConfirmModal = new ModalParams({ onClose: null });
        this.statusConfirmModal.onConfirm = async () => { this.statusConfirmModal.close(); await this.openFacilityOrderNewFlowInventoryCountEditModal(); };
        this.statusConfirmModal.onCancel = () => { this.statusConfirmModal.close() };
        this.statusConfirmModal.yesLabel = 'MODAL.START_ANYWAYS_LABEL';
        this.statusConfirmModal.noLabel = 'MODAL.CANCEL_LABEL';
        this.statusConfirmModal.swapButtons = true;

        this.updateInventoryCountInfoModal = new ModalParams({ onClose: null });
        this.updateInventoryCountInfoModal.onConfirm = async () => { this.updateInventoryCountInfoModal.close(); };
        this.updateInventoryCountInfoModal.yesLabel = 'MODAL.ACKNOWLEDGE';
        this.updateInventoryCountInfoModal.doNotShowCancel = true;

        this.productStore = new BaasicDropdownStore({
            filterable: true, initFetch: false
        }, {
            fetchFunc: async (term) => {
                const response = await this.productService.find({
                    sort: "itemId|asc",
                    searchQuery: term,
                    rpp: 100,
                    isActive: true,
                    procedureCodesToExclude: "B9002,E0776",
                    unitOfMeasureIdToExclude: this.lookups.unitOfMeasure.find(uom => uom.abrv == "CA").id,
                    subCategoryIdToExclude: this.lookups.subCategory.find(s => s.abrv === "G-Tube").id
                });

                var items = response.data.item.filter(p => !p.itemId.toLowerCase().includes("-cs"));

                return _.map(items, item => {
                    return {
                        id: item.id,
                        name: item.itemId + ' ' + item.description,
                        itemId: item.itemId,
                        description: item.description,
                        qtyPerCase: item.qtyPerCase ? item.qtyPerCase : 0
                    };
                });
            }
        });

        this.fetch([
            this.initialize()
        ]);
    }

    @action.bound
    async initialize() {
        this.page = "inventory"
        const isInventoryStepAllowed = (await this.facilityOrderService.isNikoInventoryStepAllowed(this.id)).data;
        if (!isInventoryStepAllowed) {
            return this.rootStore.routerStore.goTo('master.app.main.niko-facility-order.order-summary-preview', { id: this.id });
        }

        await this.initializeFacilityOrder();
        await this.initializeLookups();
        await this.productStore.filterAsync();
        await this.getInventoryCount();
        await this.getInventoryCalculation();
        if (this.isOpenInventoryCalculation) {
            this.isOpenInventoryCount = false;
        }

        const typeResponse = await this.scheduleService.getTypes();
        this.orderType = _.find(typeResponse.item, { abrv: 'ordering' });
    }

    @action.bound
    async initializeFacilityOrder() {
        const response = await this.facilityOrderService.get(this.id, { embed: "Facility,Facility.FacilityAreaOfCares,Facility.Corporate_,FacilityOrderStatuses" });
        const facilityOrder = response.data;
        const hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedNikoInventoryEmailConditions(this.id)).data;
        const isMissingInventoryFor2PreviousOrders = await this.facilityOrderService.checkPreviousFacilityOrders(facilityOrder.id);
        const facilityOrderStatus = facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'inventory');
        this.rootStore.titleStore.setTitle(`Inventory - ${facilityOrder.facility.name}`);
        runInAction(() => {
            this.facilityOrder = facilityOrder;
            this.isInventoryStepAllowed = true;
            this.hideInventoryEmailButton = hideInventoryEmailButton;
            this.isInventoryFollowupEmail = facilityOrder.isInventoryRequestSent && !facilityOrder.missingInventoryCount && !hideInventoryEmailButton;
            this.isInventoryNotReceivedEmail = facilityOrder.isInventoryRequestSent && facilityOrder.missingInventoryCount && !hideInventoryEmailButton;
            this.isOngoingMissingInventoryEmail = facilityOrder.isInventoryRequestSent && facilityOrder.missingInventoryCount && isMissingInventoryFor2PreviousOrders.data && !hideInventoryEmailButton;
            this.facilityOrderStatus = facilityOrderStatus;
            this.disabled = !(facilityOrderStatus && facilityOrderStatus.startedOn && !facilityOrderStatus.completedOn);
            this.isDone = facilityOrderStatus && facilityOrderStatus.startedOn && facilityOrderStatus.completedOn;
            this.disabledSendOrder = !this.isAdmin && facilityOrder && facilityOrder.sendOrder;
        });
    }

    @action.bound
    async getFacilityEmergencySupplyDays() {
        const response = await this.facilityService.get(this.facilityOrder.facilityId, { fields: "EmergencySupplyDays" });
        this.facilityOrder.facility.emergencySupplyDays = response.data.emergencySupplyDays;
    }

    @action.bound
    async initializeLookups() {
        this.lookups = await this.lookupService.getLookups("ImportHeaderStatus,UnitOfMeasure,SubCategory");
    }

    @action.bound
    async getInventoryCount() {
        if (this.facilityOrder.facilityInventoryCountHeaderId) {
            this.facilityInventoryCountHeader = (await this.facilityInventoryCountHeaderService.get(this.facilityOrder.facilityInventoryCountHeaderId)).data;
            var params = { facilityInventoryCountHeaderId: this.facilityOrder.facilityInventoryCountHeaderId, rpp: 100, embed: 'Product', sort: 'ItemType|asc' };
            const response = await this.facilityInventoryCountDetailService.find(params);
            const responseData = _.extend(response.data, {
                item: _.map(response.data.item, (item => {
                    return _.extend(
                        item, {
                        itemId: item.product && item.product.itemId,
                        description: item.product && item.product.description,
                        quantity: item.quantity,
                        action: ""
                    }
                    );
                }))
            });

            var caseResponseData = null;
            if (responseData.item.length > 0) {
                var caseProducts = responseData.item.map(e => e.itemId.toLowerCase().replace("-n", "-cs-n").replace("-b", "-cs-b"));
                if (caseProducts.filter(p => p.indexOf("-cs") > -1).length > 0) {
                    caseResponseData = (await this.productService.find({ itemIds: caseProducts.filter(p => p.indexOf("-cs") > -1).join(','), isActive: true, rpp: 1000 })).data.item;
                }
            }

            this.facilityInventoryCountDetails = _.map(responseData.item, (item => {
                var product = caseResponseData && caseResponseData.find(x => x.itemId.toLowerCase().replace("-cs-n", "-n").replace("-cs-b", "-b") === item.itemId.toLowerCase());
                return _.extend(
                    item,
                    product && product.qtyPerCase && product.qtyPerCase > 0 ?
                        { caseQty: (item.quantity !== null ? (item.quantity > 0 ? Math.floor(item.quantity / product.qtyPerCase) : 0) : null), eachQty: (item.quantity !== null ? (item.quantity > 0 ? (item.quantity % product.qtyPerCase) : 0) : null), qtyPerCase: product.qtyPerCase, hasCaseProduct: true } :
                        (item.quantity !== null ? { caseQty: 0, eachQty: item.quantity, qtyPerCase: 0, hasCaseProduct: !!product } : { caseQty: null, eachQty: null, qtyPerCase: 0, hasCaseProduct: !!product })
                );
            }));
        } else {
            this.facilityInventoryCountHeader = null;
        }
    }

    @action.bound
    async getInventoryCalculation() {
        this.facilityInventoryCalculation = await this.facilityInventoryCalculationService.getExisting(this.facilityOrder.id);
        if (this.facilityInventoryCalculation) {
            if (this.facilityInventoryCalculation.isDone) {
                this.disabled = true;
                this.isDone = true;
            }

            const params = { rpp: 100, sort: 'Quantity|desc', embed: 'Product,InventoryCalculationCutbacks', facilityInventoryCalculationId: this.facilityInventoryCalculation.id };
            const response = await this.facilityInventoryCalculationItemService.find(params);

            var caseResponse = null;
            if (response.data.item.length > 0) {
                var caseProducts = response.data.item.map(e => e.product && e.product.itemId.toLowerCase().replace("-n", "-cs-n").replace("-b", "-cs-b"));
                if (caseProducts.filter(p => p.indexOf("-cs") > -1).length > 0) {
                    caseResponse = (await this.productService.find({ itemIds: caseProducts.filter(p => p.indexOf("-cs") > -1).join(','), isActive: true, rpp: 1000 })).data.item;
                }
            }
            var responseData = _.extend(response.data, {
                item: await Promise.all(response.data.item.map(async item => {
                    var adjustedQtyArray = [];
                    _.forEach(item.inventoryCalculationCutbacks, function (item) {
                        adjustedQtyArray.push(parseInt(item.adjustedQty));
                    })
                    var adjustedQuantitySum = _.sum(adjustedQtyArray);
                    var product = caseResponse && item.product && caseResponse.find(x => x.itemId.toLowerCase().replace("-cs-n", "-n").replace("-cs-b", "-b") === item.product.itemId.toLowerCase());

                    const responseCutbacks = await this.inventoryCalculationCutbackService.find({
                        calculationItemId: item.id,
                        embed: "PatientTemplateItem",
                        rpp: 100
                    });
                    let showIcon = responseCutbacks && responseCutbacks.data && responseCutbacks.data.item && responseCutbacks.data.item.some(cutback => {
                        let clinicalStatus = cutback.clinicalStatusName;
                        const isEligible = cutback.eligibilityStatusName === "Eligible";
                        const isCoveredOrAuthStatus = (
                            clinicalStatus === "Covered" ||
                            clinicalStatus === "Prior Auth Obtained" ||
                            clinicalStatus === "Prior Auth Required" ||
                            clinicalStatus === "Prior Auth Pending" ||
                            clinicalStatus === "Does Not Meet Insurance Criteria" ||
                            clinicalStatus == null
                        );
                        return !(isEligible && isCoveredOrAuthStatus);
                    });

                    let obj = _.extend(
                        item, {
                        itemId: item.product && item.product.itemId,
                        product: item.product && item.product.description,
                        qtyPerCase: product && product.qtyPerCase ? product.qtyPerCase : 0,
                        hasCaseProduct: !!product,
                        quantity: item.quantity,
                        salesOrderQty: item.salesOrderQty,
                        inventoryCountQty: item.inventoryCountQty,
                        calculatedQty: Math.abs(item.calculatedQuantity),
                        isDone: this.facilityInventoryCalculation.isDone,
                        type: item.calculatedQuantity < 0 ? "ExtraSupplies" : item.calculatedQuantity > 0 ? "Cutback" : "NoType",
                        totalCutbackQty: item.calculatedQuantity > 0 ? adjustedQuantitySum : '',
                        stockNeededQuantity: item.salesOrderQty + item.quantity,
                        totalCaseAndEachQty: 0,
                        showIcon: showIcon
                    }
                    );
                    this.calculateTotalCaseAndEachQty(obj);
                    return obj;
                }))
            });

            this.facilityInventoryCalculationItemsGroup = _.groupBy(responseData.item, 'type');

            this.isOpenInventoryCalculation = true;
            this.isOpenInventoryCount = false;

            this.isApprovalRequired = this.facilityOrder.facility && this.facilityOrder.facility.corporate_ && this.facilityOrder.facility.corporate_.approvalRequiredExtraSupplies && this.facilityInventoryCalculationItemsGroup && this.facilityInventoryCalculationItemsGroup['ExtraSupplies'] && this.facilityInventoryCalculationItemsGroup['ExtraSupplies'].some(x => x.actualCutbackExtraSuppliesQuantity > 0);

            this.isApprovalRequired = this.facilityOrder.facility && this.facilityOrder.facility.corporate_ && this.facilityOrder.facility.corporate_.approvalRequiredExtraSupplies && this.facilityInventoryCalculationItemsGroup && this.facilityInventoryCalculationItemsGroup['ExtraSupplies'] && this.facilityInventoryCalculationItemsGroup['ExtraSupplies'].some(x => x.actualCutbackExtraSuppliesQuantity > 0);

            this.rebuildTooltip = true;
            this.rebuildTooltip = false;
        }
    }

    calculateTotalCaseAndEachQty(item) {
        let qty = item.calculatedQuantity < 0 ? item.salesOrderQty + item.actualCutbackExtraSuppliesQuantity : item.calculatedQuantity > 0 ? item.salesOrderQty - item.totalCutbackQty : item.salesOrderQty;
        // if (qty == 0)
        //     item.totalCaseAndEachQty = item.salesOrderQty;
        // else {
        item.totalCaseAndEachQty = item.qtyPerCase == 0 ? `0 CS, ${qty} EA` : `${Math.floor(qty / item.qtyPerCase)} CS, ${qty % item.qtyPerCase} EA`;
        // }
    }

    @action.bound
    async startInventoryCount() {
        this.isLoading = true;
        const clinicalReviewStatus = await this.getClinicalStatus();
        if (clinicalReviewStatus && clinicalReviewStatus.completedOn) {
            await this.openFacilityOrderNewFlowInventoryCountEditModal();
        }
        else {
            this.statusConfirmModal.open({
                message: "Clinical Review has not yet completed their flow."
            });
        }
        this.isLoading = false;
    }

    @action.bound
    async copyFollowUpTemplateToClipboard() {
        try {
            let response = await this.inventoryRequestService.getInventoryFollowUpPrefill(this.facilityOrder.id);
            await navigator.clipboard.write([
                new window.ClipboardItem({
                    "text/html": new Blob([response.data], { type: "text/html" }),
                    "text/plain": new Blob([response.data], { type: "text/plain" })
                })
            ]);
        } catch (err) {
            this.rootStore.notificationStore.error('Inventory Follow-Up e-mail failed to copy.', err);

        }
        this.rootStore.notificationStore.success('Inventory Follow-Up successfully copied to clipboard.');
    }

    @action.bound
    async copyInventoryNotReceivedTemplateToClipboard() {
        try {
            let response = await this.inventoryRequestService.getInventoryNotReceivedPrefill(this.facilityOrder.id);
            await navigator.clipboard.write([
                new window.ClipboardItem({
                    "text/html": new Blob([response.data], { type: "text/html" }),
                    "text/plain": new Blob([response.data], { type: "text/plain" })
                })
            ]);
        } catch (err) {
            this.rootStore.notificationStore.error('Inventory Not Received e-mail failed to copy.', err);
        }
        this.rootStore.notificationStore.success('Inventory Not Received successfully copied to clipboard.');
    }

    @action.bound
    async copyInventoryAsssitanceRequestEmail() {
        try {
            let response = await this.inventoryRequestService.getInventoryAssistanceRequestPrefill(this.facilityOrder.id);
            await navigator.clipboard.write([
                new window.ClipboardItem({
                    "text/html": new Blob([response.data], { type: "text/html" }),
                    "text/plain": new Blob([response.data], { type: "text/plain" })
                })
            ]);
        } catch (err) {
            this.rootStore.notificationStore.error('Inventory Assistance e-mail failed to copy.', err);
        }
        this.rootStore.notificationStore.success('Inventory Assistance Request successfully copied to clipboard.');
    }

    @action.bound
    openOngoingMissingInventoryWindow() {
        window.open(`${this.rootStore.routerStore
            .findRoute('master.app.main.niko-facility-order.niko-ongoing-missing-inventory.new-flow-edit-email')
            .pattern.replace(":facilityOrderId", this.id)}
            `);
    }

    @action.bound
    async openFacilityOrderNewFlowInventoryCountEditModal() {
        await this.getFacilityEmergencySupplyDays();
        this.nikoFacilityOrderNewFlowInventoryCountEditModal.open({
            facilityOrder: this.facilityOrder,
            facilityInventoryCountHeader: this.facilityInventoryCountHeader,
            refreshInventoryCalculation: this.facilityInventoryCalculation ? () => this.refreshInventoryCalculation() : null,
            getFacilityOrderStatuses: () => this.getFacilityOrderStatuses()
        });
    }

    async getClinicalStatus() {
        let clinicalReviewStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'clinical-review');
        if (!(clinicalReviewStatus && clinicalReviewStatus.completedOn)) {
            var statusesResponse = await this.facilityOrderStatusService.find({ facilityOrderId: this.facilityOrder.id, embed: "Status,StartedByUser,CompletedByUser" });
            if (statusesResponse.data) {
                clinicalReviewStatus = statusesResponse.data.item.find(i => i.status.abrv === 'clinical-review');
            }
        }
        return clinicalReviewStatus;
    }

    @action.bound
    async createInventoryCalculation() {
        if (await this.updateInventoryCount()) {
            return;
        }

        this.isLoading = true;
        this.disabled = !(this.facilityOrderStatus && this.facilityOrderStatus.startedOn);
        var userId = this.rootStore.userStore.user.id;
        var response = await this.facilityInventoryCalculationService.nikoFlowCreate({
            createdByUserId: userId,
            facilityOrderId: this.facilityOrder.id
        });

        if (response.data && response.data.isAutoSupplyEnfitAdapter) {
            this.showAutoSupplyEnfitAdapterNotification();
        }

        this.isOpenInventoryCount = false;
        await this.getFacilityEmergencySupplyDays();
        await this.getInventoryCalculation();

        if (!Object.keys(this.facilityInventoryCalculationItemsGroup).length) {
            this.rootStore.notificationStore.warning('There are no items for Inventory Calculation.');
            this.isOpenInventoryCalculation = false;
            this.isOpenInventoryCount = true;
        } else if (this.facilityInventoryCountDetails.some(i => !i.isSibling && i.quantity === null && i.product.subCategory.itemCategory.abrv.toLowerCase() === 'enteral')) {
            this.rootStore.notificationStore.warning('Extra Supplies are not calculated for any item without a quantity. If you would like to have ES calculated, change the qty to “0” on the “Inventory Count” instead of leaving it blank.');
        }

        this.isLoading = false;
    }

    @action.bound
    setCardVisibility(isInventoryCount) {
        if (isInventoryCount) {
            this.isOpenInventoryCount = !this.isOpenInventoryCount;
        }
        else {
            this.isOpenInventoryCalculation = !this.isOpenInventoryCalculation;
        }
    }

    @action.bound
    async getFacilityOrderStatuses() {
        try {
            var statusesResponse = await this.facilityOrderStatusService.find({ facilityOrderId: this.facilityOrder.id, embed: "Status,StartedByUser,CompletedByUser" });
            if (statusesResponse.data) {
                this.facilityOrder.facilityOrderStatuses = statusesResponse.data.item;
                this.facilityOrderStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'inventory');
            }
            this.disabled = false;
            this.changeStatusBarVisibility();
            this.changeStatusBarVisibility();

            this.hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedNikoInventoryEmailConditions(this.facilityOrder.id)).data;
            let isMissingInventoryFor2PreviousOrders = await this.facilityOrderService.checkPreviousFacilityOrders(this.facilityOrder.id);

            this.isInventoryNotReceivedEmail = this.facilityOrder.isInventoryRequestSent && this.facilityOrder.missingInventoryCount && !this.hideInventoryEmailButton;
            this.isOngoingMissingInventoryEmail = this.facilityOrder.isInventoryRequestSent && this.facilityOrder.missingInventoryCount && isMissingInventoryFor2PreviousOrders.data && !this.hideInventoryEmailButton;
            this.refreshKey = uuid();
        }
        catch (err) {
            this.rootStore.notificationStore.error("The facility order status has already been updated. Please reload the page.");
        }
    }

    @action.bound
    async openFacilityOrderNewFlowInventoryCalculationProcessModal() {
        await this.getFacilityEmergencySupplyDays();
        this.isProcessing = true;
        this.nikoFacilityOrderNewFlowInventoryCalculationProcessModal.open({
            id: this.facilityInventoryCalculation.id,
            approvalRequired: this.isApprovalRequired,
            setInventoryCompleted: async () => {
                try {
                    await this.setInventoryCompleted();
                } finally {
                    this.isProcessing = false;
                }
            },
            onClose: () => { this.isProcessing = false; },
            getInventoryCalculation: () => this.getInventoryCalculation()
        });
    }

    @action.bound
    async setInventoryCompleted() {
        try {
            var statusesResponse = await this.facilityOrderStatusService.find({ facilityOrderId: this.facilityOrder.id, embed: "Status,StartedByUser,CompletedByUser" });
            if (statusesResponse.data) {
                this.facilityOrder.facilityOrderStatuses = statusesResponse.data.item;
                this.facilityOrderStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'inventory');
                if (this.facilityOrderStatus && this.facilityOrderStatus.completedOn) {
                    this.disabled = true;
                    this.isDone = true;
                }
            }

            this.changeStatusBarVisibility();
            this.changeStatusBarVisibility();
        }
        catch (err) {
            this.rootStore.notificationStore.error("The facility order status has already been updated. Please reload the page.");
        }
    }

    @action.bound
    changeStatusBarVisibility() {
        this.isStatusBarVisible = !this.isStatusBarVisible;
    }

    @action.bound
    editFacility() {
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.facility.edit').pattern.replace(":id", this.facilityOrder.facilityId)}`);
    }

    @action.bound
    async downloadInventoryCount() {
        var params = { facilityInventoryCountHeaderId: this.facilityOrder.facilityInventoryCountHeaderId, rpp: 100, embed: 'Product', sort: 'ItemType|asc' };
        const downloadUrl = `${this.facilityInventoryCountDetailService.getNewDownloadInventoryDetailUrl({
            ...params
        })}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
        window.open(downloadUrl, "_blank");
    }

    @action.bound
    addInventoryCountDetail() {
        this.facilityInventoryCountDetails.push({
            id: uuid(),
            caseQty: null,
            eachQty: null,
            facilityInventoryCountHeader: null,
            facilityInventoryCountHeaderId: this.facilityOrder.facilityInventoryCountHeaderId,
            templateQuantity: 0,
            product: null,
            productId: null,
            itemId: null,
            qtyPerCase: 0,
            quantity: null,
            action: "",
            isNew: true
        });
    }

    @action.bound
    async saveInventoryCountDetail(index, product) {
        if (this.facilityInventoryCountDetails.some(item => item.productId === product.id)) {
            this.rootStore.notificationStore.error('FACILITY_ORDER_NEW_FLOW_INVENTORY.EDIT_INVENTORY_COUNT.PRODUCT_ALREADY_EXIST')
            return;
        }

        this.disabled = true;
        this.disabledCount = true;
        try {
            if (this.facilityInventoryCalculation) {
                this.facilityInventoryCountDetails[index].action = "create";
            }
            else {
                var response = await this.facilityInventoryCountDetailService.create(
                    {
                        facilityInventoryCountHeaderId: this.facilityInventoryCountDetails[index].facilityInventoryCountHeaderId,
                        productId: product.id,
                        quantity: 0
                    }
                );
                if (response.data) {
                    this.facilityInventoryCountDetails[index].id = response.data.id;
                }
            }

            this.facilityInventoryCountDetails[index].product = product;
            this.facilityInventoryCountDetails[index].productId = product.id;
            this.facilityInventoryCountDetails[index].itemId = product.itemId;

            product.qtyPerCase = 0;
            var caseProducts = product.itemId.toLowerCase().replace("-n", "-cs-n").replace("-b", "-cs-b");
            if (caseProducts) {
                const caseResponseData = (await this.productService.find({ itemIds: caseProducts, isActive: true, rpp: 1 })).data.item;
                if (caseResponseData && caseResponseData[0]) {
                    product.qtyPerCase = caseResponseData[0].qtyPerCase || 0;
                    this.facilityInventoryCountDetails[index].hasCaseProduct = true;
                }
            }
            this.facilityInventoryCountDetails[index].qtyPerCase = product.qtyPerCase;

        } catch (err) {
            this.rootStore.notificationStore.error('EDIT_FORM_LAYOUT.ERROR_CREATE', err);
        }
        this.disabled = false;
        this.disabledCount = false;
    }

    @action.bound
    async deleteInventoryCountDetail(index) {
        this.disabled = true;
        this.disabledCount = true;
        try {
            if (this.facilityInventoryCalculation) {
                this.facilityInventoryCountDetails[index].action = "delete";
            }
            else {
                if (this.facilityInventoryCountDetails[index].product) {
                    await this.facilityInventoryCountDetailService.delete(this.facilityInventoryCountDetails[index]);
                }
                this.facilityInventoryCountDetails.splice(index, 1);
            }
        } catch (err) {
            this.rootStore.notificationStore.error('LIST_LAYOUT.ERROR_DELETE', err);
        }
        this.disabled = false;
        this.disabledCount = false;
    }

    @action.bound
    isQtyValid(value, propertyName) {
        if (parseFloat(value).toFixed(2) > 999.99 && (propertyName === 'quantity' || propertyName === 'caseQty' || propertyName === 'eachQty')) {
            return false;
        }
        return true;
    }

    @action.bound
    editInventoryCountDetail(index, value, propertyName) {
        if (!this.isQtyValid(value, propertyName)) {
            return;
        }

        if (value == null || value == undefined || value === "") {
            this.facilityInventoryCountDetails[index][propertyName] = null;
            return;
        }

        this.facilityInventoryCountDetails[index][propertyName] = parseFloat(value);
    }

    @action.bound
    async updateInventoryCountDetail(index, value, propertyName) {
        if (this.facilityInventoryCountDetails[index].qtyPerCase === 0) {
            if (value === null) {
                this.facilityInventoryCountDetails[index].caseQty = null;
                this.facilityInventoryCountDetails[index].eachQty = null;
                this.facilityInventoryCountDetails[index].quantity = null;
            } else {
                if (propertyName === "caseQty" && this.facilityInventoryCountDetails[index].eachQty === null) {
                    this.facilityInventoryCountDetails[index].eachQty = 0;
                }
                if (propertyName === "eachQty" && this.facilityInventoryCountDetails[index].caseQty === null) {
                    this.facilityInventoryCountDetails[index].caseQty = 0;
                }
                this.facilityInventoryCountDetails[index].quantity = this.facilityInventoryCountDetails[index].eachQty;
            }
        }
        else {
            if (propertyName === "eachQty" && value && value >= this.facilityInventoryCountDetails[index].qtyPerCase) {
                this.facilityInventoryCountDetails[index].caseQty += Math.floor(value / this.facilityInventoryCountDetails[index].qtyPerCase);
                value = value % this.facilityInventoryCountDetails[index]["qtyPerCase"];
                this.facilityInventoryCountDetails[index].eachQty = value;
            }

            if (value === null) {
                this.facilityInventoryCountDetails[index].caseQty = null;
                this.facilityInventoryCountDetails[index].eachQty = null;
                this.facilityInventoryCountDetails[index].quantity = null;
            } else {
                if (propertyName === "caseQty" && this.facilityInventoryCountDetails[index].eachQty === null) {
                    this.facilityInventoryCountDetails[index].eachQty = 0;
                }
                if (propertyName === "eachQty" && this.facilityInventoryCountDetails[index].caseQty === null) {
                    this.facilityInventoryCountDetails[index].caseQty = 0;
                }
                this.facilityInventoryCountDetails[index].quantity = (this.facilityInventoryCountDetails[index].qtyPerCase * this.facilityInventoryCountDetails[index].caseQty) + this.facilityInventoryCountDetails[index].eachQty;
            }
        }

        if (!this.facilityInventoryCalculation) {
            await this.facilityInventoryCountDetailService.updateQuantity({
                id: this.facilityInventoryCountDetails[index].id,
                quantity: this.facilityInventoryCountDetails[index].quantity
            });
        }
        else if (this.facilityInventoryCountDetails[index].action === "") {
            this.facilityInventoryCountDetails[index].action = "update";
        }

        if (this.facilityInventoryCountDetails[index].qtyPerCase === 0 && propertyName === "caseQty" && value != 0 && value != null) {
            this.rootStore.notificationStore.error(this.facilityInventoryCountDetails[index].hasCaseProduct ? 'Case Qty cannot be entered for a product whose case version has "Quantity per case" set to 0' : "Case Qty cannot be entered for a product that doesn't have its case version.");
            this.facilityInventoryCountDetails[index].caseQty = null;
            this.facilityInventoryCountDetails[index].eachQty = null;
            this.facilityInventoryCountDetails[index].quantity = null;
        }
    }

    @action.bound
    async refreshInventoryCalculation() {
        this.isLoading = true;
        try {

            if (this.isEdit && this.facilityInventoryCountDetails.some(i => i.action !== "")) {
                this.facilityInventoryCountDetails.filter(i => i.action !== "").forEach(async item => {
                    if (item.action === "create") {
                        await this.facilityInventoryCountDetailService.create(
                            {
                                facilityInventoryCountHeaderId: item.facilityInventoryCountHeaderId,
                                productId: item.product.id,
                                quantity: item.quantity
                            }
                        );
                    }
                    else if (item.action === "update") {
                        await this.facilityInventoryCountDetailService.updateQuantity({
                            id: item.id,
                            quantity: item.quantity
                        });
                    }
                    else if (item.action === "delete") {
                        if (item.isNew) {
                            return;
                        }
                        await this.facilityInventoryCountDetailService.delete(item);
                    }
                });
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error('EDIT_FORM_LAYOUT.ERROR_UPDATE', err);
        }

        if (await this.updateInventoryCount()) {
            this.isLoading = false;
            return;
        }

        try {
            await this.getFacilityEmergencySupplyDays();
            await this.getInventoryCount();
            var response = await this.facilityInventoryCalculationService.nikoFlowRefresh(this.facilityInventoryCalculation.id);
            if (response && response.customValues && response.customValues.isAutoSupplyEnfitAdapter) {
                this.showAutoSupplyEnfitAdapterNotification();
            }
            this.isOpenInventoryCount = false;
        }
        catch (err) {
            this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : 'Error occurred while trying to refresh a Inventory Calculation.');
        }
        await this.getInventoryCalculation();

        if (!Object.keys(this.facilityInventoryCalculationItemsGroup).length) {
            this.rootStore.notificationStore.warning('There are no items for Inventory Calculation.');
        } else if (this.facilityInventoryCountDetails.some(i => !i.isSibling && i.quantity === null && i.product.subCategory.itemCategory.abrv.toLowerCase() === 'enteral')) {
            this.rootStore.notificationStore.warning('Extra Supplies are not calculated for any item without a quantity. If you would like to have ES calculated, change the qty to “0” on the “Inventory Count” instead of leaving it blank.');
        }

        this.isEdit = false;
        this.isLoading = false;
    }

    @action.bound
    editInventoryCalculationItem(item, value, propertyName) {
        item[propertyName] = parseInt(value);
    }

    @action.bound
    async updateInventoryCalculationItem(item, propertyName) {
        const newDisabledItems = { ...this.disabledItems };
        newDisabledItems[item.id] = true;
        this.disabledItems = newDisabledItems;

        try {
            if (propertyName === "totalCutbackQty") {
                await this.inventoryCalculationCutbackService.updateCutbackAdjustedQtyNikoFlow({ calculationItemId: item.id, adjustedQty: item[propertyName] });
                this.rootStore.notificationStore.success("Total Cutback Quantity successfully updated.");
            } else {
                await this.facilityInventoryCalculationItemService.updateActualCutbackExtraSuppliesQuantity({ id: item.id, actualQuantity: item[propertyName] });
                this.isApprovalRequired = this.facilityOrder.facility && this.facilityOrder.facility.corporate_ && this.facilityOrder.facility.corporate_.approvalRequiredExtraSupplies && this.facilityInventoryCalculationItemsGroup && this.facilityInventoryCalculationItemsGroup['ExtraSupplies'] && this.facilityInventoryCalculationItemsGroup['ExtraSupplies'].some(x => x.actualCutbackExtraSuppliesQuantity > 0);
            }
            this.calculateTotalCaseAndEachQty(item);
        } catch (err) {
            await this.getInventoryCalculation();
            this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : "Error occurred while trying to change Actual CB/ES Quantity.");
        }
        finally {
            const newDisabledItems = { ...this.disabledItems };
            newDisabledItems[item.id] = false;
            this.disabledItems = newDisabledItems;
        }
    }

    @action.bound
    async openFacilityOrderNewFlowInventoryCalculationVerificationModal(item) {
        this.nikoFacilityOrderNewFlowInventoryCalculationVerificationModal.open({
            facilityInventoryCalculationItem: item
        });
    }

    @action.bound
    async openFacilityOrderNewFlowInventoryCalculationCutbackEditModal(item, isCutback) {
        this.nikoFacilityOrderNewFlowInventoryCalculationCutbackEditModal.open({
            facilityInventoryCalculationItem: item,
            isCutback: isCutback,
            disabled: this.disabled,
            isDone: this.isDone,
            disabledItems: this.disabledItems,
            onCutbackItemUpdate: this.onCutbackItemUpdate
        });
    }

    @action.bound
    onCutbackItemUpdate(itemId, updating) {
        const newDisabledItems = { ...this.disabledItems };
        newDisabledItems[itemId] = updating;
        this.disabledItems = newDisabledItems;
    }

    @action.bound
    async deleteInventoryCalculationItem(item) {
        const { modalStore, notificationStore } = this.rootStore;
        modalStore.showConfirm(
            'FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.DELETE.PRODUCT',
            async () => {
                this.disabled = true;
                try {
                    await this.facilityInventoryCalculationItemService.delete(item);
                    await this.getInventoryCalculation();
                } catch (err) {
                    notificationStore.error('FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.DELETE.PRODUCT_ERROR', err);
                }
                this.disabled = false;
            }
        );
    }

    @action.bound
    async cancelInventoryCountChanges() {
        this.disabled = true;
        this.disabledCount = true;
        await this.getInventoryCount();
        this.isEdit = false;
        this.disabled = false;
        this.disabledCount = false;
    }

    @action.bound
    editInventoryCount() {
        this.isEdit = true;
        this.isOpenInventoryCalculation = false;
    }

    @action.bound
    uploadInventoryCount() {
        this.rootStore.routerStore.goTo(
            "master.app.main.facility-inventory.file-upload",
            {
                facilityInventoryCountHeaderId: this.facilityOrder.facilityInventoryCountHeaderId
            }
        );
    }

    @action.bound
    openfacilityOrderNewFlowMissingInventoryCountConfirmModal() {
        this.nikoFacilityOrderNewFlowMissingInventoryCountConfirmModal.open({
            facilityOrder: this.facilityOrder,
            getFacilityOrderStatuses: async () => await this.getFacilityOrderStatuses()
        });
    }

    @action.bound
    openFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal() {
        this.nikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal.open({
            facilityOrder: this.facilityOrder,
            facilityInventoryCountHeader: this.facilityInventoryCountHeader,
            refreshInventoryCalculation: this.facilityInventoryCalculation ? () => this.refreshInventoryCalculation() : null
        });
    }

    @action.bound
    showAutoSupplyEnfitAdapterNotification() {
        this.rootStore.notificationStore.success('FACILITY_ORDER_NEW_FLOW_INVENTORY.PREVIEW.AUTO_SUPPLY_ENFIT_ADAPTER');
    }

    @action.bound
    openExtraSuppliesModal() {
        if (this.facilityOrder.facility.corporate_ && this.facilityOrder.facility.corporate_.approvalRequiredExtraSupplies) {
            this.extraSuppliesApprovalRequiredModal.yesLabel = 'MODAL.YES';
            this.extraSuppliesApprovalRequiredModal.onConfirm = async () => { this.extraSuppliesApprovalRequiredModal.close(); await this.openFacilityOrderNewFlowExtraSuppliesAddModal(); };
            this.openExtraSuppliesApprovalRequiredModal();
        }
        else {
            this.openFacilityOrderNewFlowExtraSuppliesAddModal();
        }
    }

    @action.bound
    openFacilityOrderNewFlowExtraSuppliesAddModal() {
        this.facilityOrderNewFlowExtraSuppliesAddModal.open({
            facilityOrderId: this.facilityOrder.id,
            facilityId: this.facilityOrder.facilityId,
            sendAgoraPo: this.facilityOrder.facility.sendAgoraPo,
            skipAutoItems: true
        });
    }

    @action.bound
    openExtraSuppliesApprovalRequiredModal(message) {
        this.extraSuppliesApprovalRequiredModal.open({
            question: 'MODAL.QUESTION_EXTRA_SUPPLIES_APPROVAL',
            message: message
        });
    }

    @action.bound
    signalRAction(message) {
        if (message.table === "PTI") {
            if (this.isProcessing) return false;
            if (this.facilityInventoryCalculation) {
                this.facilityInventoryCalculation.isDirty = true;
            }
        }

        else if (message.table == "FO" && message.column == "SendOrder") {
            this.facilityOrder.sendOrder = true;
            this.disabledSendOrder = !this.isAdmin;
        }
        else if (message.table == "IC") {
            if (this.facilityInventoryCalculation) {
                this.facilityInventoryCalculation.isDirty = false;
            }
        }
        else if (message.table === "FOS") {
            this.refreshFacilityOrderStatus();
        }
    }

    @action.bound
    async refreshFacilityOrderStatus() {
        var statusesResponse = await this.facilityOrderStatusService.find({ facilityOrderId: this.facilityOrder.id, embed: "Status,StartedByUser,CompletedByUser" });
        if (statusesResponse.data) {
            this.facilityOrder.facilityOrderStatuses = statusesResponse.data.item;
        }
        this.refreshKey = uuid();
    }

    @action.bound
    orderHistory() {
        window.open(this.rootStore.routerStore.findRoute("master.app.main.niko-facility-order.history").pattern.replace(":id", this.facilityOrder.id));
    }

    @action.bound
    async goToFacilityPreview() {
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.facility.preview').pattern.replace(":id", this.facilityOrder.facilityId)}`);
    }

    @action.bound
    async goToFacilityCalendar() {
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.schedule.calendar').pattern}?facilityId=${this.facilityOrder.facilityId}&calendarTypeId=${this.orderType.id}`);
    }

    @action.bound
    async downloadFacilityOrder() {

        const downloadUrl = `${(await this.facilityOrderTemplateService.getDownloadNewFlowUrl({ facilityOrderId: this.facilityOrder.id }))}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl
            }&ttype=${this.rootStore.authStore.token.type}`
        window.open(downloadUrl, "_blank")
    }

    @action.bound
    async updateInventoryCount(showMessage = false) {
        this.isUpdateInventoryCountLoading = true;
        const response = await this.facilityInventoryCountDetailService.updateNikoFacilityInventoryCountDetails(this.facilityOrder.facilityInventoryCountHeaderId);
        if (showMessage && response && response.data && response.data.errors && response.data.errors[0]) {
            this.rootStore.notificationStore.warning(response.data.errors[0]);
            this.isUpdateInventoryCountLoading = false;
            return;
        }
        if (response.data.success) {
            await this.cancelInventoryCountChanges();
            // this.updateInventoryCountInfoModal.open({
            //     message: "Additional enteral item(s) have been added to the inventory count. Please add inventory counts where applicable and refresh the calculation."
            // });
            this.rootStore.notificationStore.success("Additional enteral item(s) have been added to the inventory count.");
            this.isUpdateInventoryCountLoading = false;
            return true;
        }
        this.isUpdateInventoryCountLoading = false;
        return false;
    }
}

export default NikoFacilityOrderNewFlowInventoryPreviewViewStore;
